import { createContext } from 'react'
import { type ApiContextBag } from './types'

export const ApiContext = createContext<ApiContextBag>({
  git: '',
  wts: '',
  entitlements: '',
  audience: ''
})
